/**
 * @file 主入口js
 * @author liuyanan06
 */
import Vue from 'vue';
import App from './container/App.vue';
import router from './router';
import store from './store/index';
import VueLazyload from 'vue-lazyload';
import {ErrorLoading} from '@baidu/map-mui';
import {Loading, Toast} from '@baidu/onemap-design';
import {initVueWeirwood, requestBdApi} from '@baidu/map-fe-utils';
import debounced from './constant/debounced';
// import fastclick from 'fastclick';
// import {Loading, ErrorLoading, Toast} from '@baidu/map-mui';

// Weirwood监控
import WeirwoodJson from './weirwood.json';
process.env.NODE_ENV === 'production' && initVueWeirwood(Vue, WeirwoodJson);

// 公共样式文件
import '@/common/style/index.scss';

import './constant/haotianjing';

Vue.use(debounced);
Toast.install(Vue);
Loading.install(Vue);
ErrorLoading.install(Vue);

// // 初始化fastclick
// fastclick.attach(document.body, {});

// // 处理input ios下需要点击多下才能获取焦点
// fastclick.prototype.focus = function (targetElement) {
//     targetElement.focus();
// };

Vue.use(VueLazyload, {
    preLoad: 1.8,
    listenEvents: ['scroll', 'transitionend']
});

Vue.config.productionTip = false;

window.signinCallback = num => {
    if (parseInt(num, 10) === 1) {
        window.location.reload();
    }
    else {
        // window.location.href = 'bdapi://finishpage?needUpdate=1';
        // window.location.href = 'bdapi://goback';
        requestBdApi('bdapi://goback');
    }
};

window.stopweb = () => {};

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
